import { useTranslation } from 'react-i18next';

import styles from './payments-list.module.scss';
import { formatMonthAndYear, formatToMaxFourDigits, IconWrapper } from '@flexo/general';
import { RIGHT_DRAWER, store } from '@flexo/reducers';
import { useDispatch } from '@uiw/react-json-view';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { transformRealDataToStructuredData } from 'libs/atoms/src/lib/table/helpers';

export type PaymentsListType = 'communityPaymentsList' | 'sitePaymentsList' | 'memberPaymentsList';

export interface PaymentsListProps {
  type: PaymentsListType;
  data?: any;
}


export function PaymentsList({ type, data }: PaymentsListProps) {

  const { t } = useTranslation();
  const dispatch = store.dispatch;
  const kpi = useSelector((state: any) => state.kpi);
  const metadata = useSelector((state: any) => state.metadata);
  const [kpiData, setKpiData] = useState<any[]>([]);



  useEffect(() => {
    if (kpi?.[data?.dataItem] && kpi?.[data?.dataItem]?.length > 0) {

      const _transformedData = transformRealDataToStructuredData(kpi?.[data?.dataItem], metadata)
      const _formattedData = _transformedData?.map((period: any) => {

        const startDate = period?.sites[0]?.period_start_date;
        const endDate = period?.sites[0]?.period_end_date;
        const _periodString = `${formatMonthAndYear(startDate, true)} - ${formatMonthAndYear(endDate, true)}`;
        return {
          ...period,
          period: _periodString,
        }
      })

      setKpiData(_formattedData)
    }
  }, [kpi?.[data?.dataItem]])

  return <div className={styles.Payments__List}>
    <p
      className={styles.Payments__List__Title}
      onClick={() => {

        if (kpiData?.length < 1) { return }
        
        dispatch(RIGHT_DRAWER.SetDrawer({
          type: 'COMMUNITY_PAYMENTS_LIST',
          show: true,
          drawerConfig: {
            title: t('widgets.tables.InvoicesPeriodTable.title', { communityName: metadata.selectedEntity?.communityName }),
            subtitle: t('widgets.tables.InvoicesPeriodTable.subtitle'),
            data: kpiData
          }
        } as any) as any)
      }}
    >
      {t(data.title)}
      <IconWrapper iconName="chevron-right" />
    </p>
    <div className={styles.Payments__List__Content}>
      {
        (kpiData || [])
          ?.filter((_, invoiceIndex) => invoiceIndex < 4)
          ?.map((period: any, periodIndex: number) => {


            const _paidSites = period?.sites?.filter((site: any) => site?.paid);
            const _totalSites = period?.sites?.length;
            const _allSitesPaid = _paidSites?.length === _totalSites;

            const _totalAmount = period?.sites?.reduce((acc: number, site: any) => acc + site?.amount, 0);
            const _totalAmountPaid = period?.sites?.reduce((acc: number, site: any) => acc + (site?.paid ? site?.amount : 0), 0);

            return <div
              className={styles.Payments__List__Content__Period__Wrapper}
              key={`${data.title}-${periodIndex}`}
            >
              <div className={styles.Payments__List__Content__Period__Info}>
                <p className={styles.Payments__List__Content__Period__Title}>{period?.period}</p>
                <p className={styles.Payments__List__Content__Period__Status}>
                  {_paidSites?.length}/{_totalSites} {t(data?.paid)}
                </p>
              </div>
              <p className={styles.Payments__List__Content__Period__Amount}>
                {_allSitesPaid && <IconWrapper iconName="check-encircled-secondary" />}
                {formatToMaxFourDigits(_totalAmountPaid)}/{formatToMaxFourDigits(_totalAmount)}
              </p>

            </div>
          })
      }
    </div>
  </div>;
}